import React, {useMemo} from "react";
import {Button, Checkbox, Col, Dropdown, Menu, Modal, Popover, Row} from "antd";
import {EditOutlined, EllipsisOutlined, FileTextOutlined, WarningOutlined} from "@ant-design/icons";
import {formatDateShort, formatGrade, formatMoney, formatPercent} from "@lib/format";
import {DiamondIcon, FlameIcon, StorageBoxOutlineIcon, UserIcon} from "@components/icons/Icons";
import {FmvPrice} from "@components/fmv-price";
import {KeyIssueBadge} from "@components/key-issue-badge";

const MyCollectionListItemDesktop = ({
     item,
     showEditMultiple,
     isSelected,
     toggleSelected,
     bookCover,
     onClick,
     issueDate,
     showPriceInfo,
     allowUnlimited,
     showDollarGains,
     notes,
     navigate,
     postRemoveIssues,
     postCloneIssue,
     onSetBoxImage,
     boxId,
     removeIssueFromBox,
     getBoxName,
     windowDimensions,
     setShowAssignPurchasePriceModalWithIssue,
     showMarkAsSold,
}) => {

    const smallButtons = useMemo(() => {
        return windowDimensions.under(1200);
    }, [windowDimensions]);

    return (
        <>
            <Row className="grid-list-item">
                {showEditMultiple && (
                    <Col span={1}  className="col-cbx">
                        {item.total_in_grade < 2 && (
                            <Checkbox
                                checked={isSelected}
                                onChange={() => toggleSelected(item.collection_item_id)}
                            />
                        )}
                    </Col>
                )}
                <Col className={smallButtons ? "width-85px" : "width-135px"}>
                    <div className="col-image">
                        {bookCover}
                    </div>
                </Col>
                <Col style={{flexGrow: 1}} className="col-desc">
                    <div className="valueBadges">
                        {item.is_key && (<KeyIssueBadge keyInfo={item.key_info} windowDimensions={windowDimensions} isLargeScreen={true} />)}
                        {item.is_hot && (<div className="valueBadge hotIssue isActive"><FlameIcon /></div>)}
                        {item.is_rare && (<div className="valueBadge rareIssue isActive"><DiamondIcon /></div>)}
                    </div>
                    <div className="col-issue-desc">
                        <div className="cursor-pointer titleLink" onClick={() => {if(onClick) onClick(item); }}>{item.series_title}: {item.issue_number}</div>
                        <span className="font-12 font-normal">
                            {item.is_variant ? item.variant_name : 'Regular'}<br/>
                            {item.publisher} | {formatDateShort(issueDate)}
                        </span>
                    </div>
                </Col>
                <Col span={smallButtons ? 3 :2} className="flex-col">
                    <div className="col-center">
                        {item.graded_by ? item.graded_by.toUpperCase() : item.graded_or_raw.toUpperCase()} | {formatGrade(item.grade)}
                    </div>
                </Col>
                <Col span={smallButtons ? 3 :2} className={"flex-col"}>
                    <div className="mar-auto-0 flex-align-center">
                        {showPriceInfo ? (
                            <>
                                <FmvPrice
                                    prefix={
                                        (item.is_most_common_value && !(item.user_value > 0) && item.most_common_grade) ?
                                            '('+formatGrade(item.most_common_grade)+') ' :
                                            null
                                    }
                                    value={item.value}
                                    stale={item.stale}
                                />
                                {(item.user_value > 0) && (
                                    <UserIcon className="grid-item-user-icon black" />
                                )}
                            </>
                        ):(
                            <a className="upgrade-link" href="/plans/unlimited/">Upgrade</a>
                        )}
                    </div>
                </Col>
                <Col
                    span={3}
                    className="flex-col min-width-110 cursor-pointer"
                    onClick={() => setShowAssignPurchasePriceModalWithIssue(item.collection_item_id)}
                >
                    <div className="col-center">
                        {formatMoney(item.total_comic_cost)}
                    </div>
                </Col>
                <Col span={3} className="flex-col min-width-145">
                        <div className={
                            "col-center " +
                            (item.user_profit ? (item.user_profit > 0 ? 'up ' : '') +
                            (item.user_profit < 0 ? 'down ' : '') : '') +
                            (item.stale ? 'stale ' : '')
                        }>
                            {allowUnlimited ? (
                                <>{showDollarGains ? formatMoney(item.user_profit, true) : formatPercent(item.user_growth)}</>
                            ) : (
                                <a className="upgrade-link" href="/plans/unlimited/">Upgrade</a>
                            )}
                        </div>
                </Col>
                <Col span={1} className="flex-col">
                    <div className="col-center">
                        {notes && (
                            <Popover content={notes}>
                                <Button className="greyButton" size={smallButtons ? "small" : "large"} >
                                    <FileTextOutlined />
                                </Button>
                            </Popover>
                        )}
                    </div>
                </Col>
                {!smallButtons && (
                    <Col span={2} className="flex-col">
                        {item.total_in_grade == 1 && (
                            <div className="col-center">
                                {allowUnlimited ? (
                                    <>
                                        {item.box_ids && (
                                            <Dropdown className="greyButton selectButton" trigger={["click"]} overlay={(
                                                <Menu >
                                                    {item.box_ids.split(',').map((id,i) => (
                                                        <Menu.Item key={i} onClick={() => navigate('box-issues?view='+id)}>{getBoxName(id)}</Menu.Item>
                                                    ))}
                                                </Menu>
                                            )}>
                                                <Button className="greyButton"  size={smallButtons ? "small" : "large"} >
                                                    {item.box_ids.split(',').length}&nbsp;<StorageBoxOutlineIcon className="icon16 iconDarkGrey" />
                                                </Button>
                                            </Dropdown>
                                        )}
                                    </>
                                ) : (
                                    <a className="upgrade-link" href="/plans/unlimited/">Upgrade</a>
                                )}
                            </div>
                        )}
                    </Col>
                )}
                <Col span={2} className="flex-col">
                    <div className="col-center">
                        <Button className="greyButton"  size={smallButtons ? "small" : "large"} onClick={() => {
                            if(onClick) onClick(item);
                        }} >
                            <EditOutlined className="font-12" />
                        </Button>

                        <Dropdown className="greyButton selectButton" trigger={["click"]} overlay={(
                            <Menu >
                                <Menu.Item key={1} onClick={() => showMarkAsSold()}>Mark as Sold</Menu.Item>
                                <Menu.Item
                                    key={2}
                                    onClick={() => Modal.confirm({
                                        autoFocusButton: null,
                                    icon: <WarningOutlined />,
                                    content: (<div>
                                        <div><b>Delete Items</b></div>
                                        <div className="pad-top-10">
                                            Are you sure?<br/>
                                            Selecting this option will permanently delete these items.
                                        </div>
                                    </div>),
                                    onOk() {
                                        postRemoveIssues({issue_ids: [item.collection_item_id]});
                                    },
                                })}
                                >Delete</Menu.Item>
                                <Menu.Item key={3} onClick={() => postCloneIssue({collection_item_id: item.collection_item_id})} >Duplicate</Menu.Item>
                                {/*<Menu.Item key={4} disabled>List for Sale</Menu.Item>*/}
                                {onSetBoxImage && (
                                    <Menu.Item key={5} onClick={() => {if(onSetBoxImage) onSetBoxImage(item.id)}} >
                                        Set as Virtual Box Image
                                    </Menu.Item>
                                )}
                                {boxId && (
                                    <Menu.Item key={7} onClick={() => removeIssueFromBox(boxId, item.collection_item_id)} >
                                        Remove from Virtual Box
                                    </Menu.Item>
                                )}
                                <Menu.Item key={6} ><a href={`/issue/${item.slug}`}>Go to Price Guide</a></Menu.Item>
                            </Menu>
                        )}>
                            <Button className="greyButton mar-left-5"  size={smallButtons ? "small" : "large"}  >
                                <EllipsisOutlined className="font-12" />
                            </Button>
                        </Dropdown>
                    </div>
                </Col>
            </Row>
        </>
    );
};

export default MyCollectionListItemDesktop;